import React, { HTMLProps } from 'react';
import { ReactNode } from 'react';

import classNames from 'classnames';

import './app-checkbox.scss';

interface AppCheckboxProps extends HTMLProps<HTMLInputElement> {
  onChangeValue: (value: boolean) => void;
  sm?: boolean;
  titleComponent?: ReactNode;
}

const AppCheckbox: React.FC<AppCheckboxProps> = ({
  checked,
  sm,
  title,
  titleComponent,
  disabled,
  className = '',
  onChangeValue,
}) => (
  <div
    className={classNames('checkbox', {
      [className]: className,
      'checkbox--sm': sm,
      'checkbox--disabled': disabled,
    })}
  >
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label onClick={(e) => e.stopPropagation()} role="presentation">
      <input
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={(e) => {
          e.stopPropagation();
          onChangeValue(e.target.checked);
        }}
      />
      <span className="checkbox__frame" />
      {title && <span className="checkbox__text">{title}</span>}
      {titleComponent && (
        <span className="checkbox__text">{titleComponent}</span>
      )}
    </label>
  </div>
);

export default AppCheckbox;
